import { render, staticRenderFns } from "./PenNibTopBarIcon.vue?vue&type=template&id=361b3278&"
import script from "./PenNibTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./PenNibTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports